module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_fds_m_jp.d52fc83f99b77e893fe58c0631d87677.png";